import create from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from 'axios';
import produce from 'immer';
import Cookies from 'js-cookie'

const useSettingsStore = create((set, get) =>  ({
    settings: {},
    selectedSetting: {},
    settingsList: [
      "setting_name",
        "max_order_size", 
        "stop_max_order_size",          
        "price_limit_is_last_ex_price",  
        "fill_delay",                   
        "depth_min",
        "depth_max", 
        "cancel_price_gap",
        "rdm_qty_range", 
        "aggro_order_on",
        "aggro_depth",
        "aggro_order_delay",
        "aggro_book_ratio",
        "aggro_forced_if_no_fill_in",
        "maker_only",
        "hedge_mode"
    ],
    settingsInputDetails: {
      "setting_name": "Aggro, Slow ... anything",
    "max_order_size": 'Order size will be capped at this value, sometimes it can round slightly over if close to min nominal.',  
    "stop_max_order_size": 'Order size of your stops/exits.',  
    "price_limit_is_last_ex_price": '0 or 1, \n your last exPrice becomes you price limit.',   
    "fill_delay": 'Will wait X seconds to send another order when filled.',
    "depth_min": 'Example: 0.001 \n how deep in the book (in %) the order is posted.',     
    "depth_max": 'Example: 0.002 \n random between depth min/depth max (must be >= depth min).', 
    "rdm_qty_range": 'If max order size is 1000 and rdm qty range is 20, the order size will be between 800 and 1000.',  
    "aggro_order_on": '0 or 1, \n will allow to be taker',
    "aggro_depth": 'With aggro order on, How deep you will try to get filled in %.',     
    "aggro_order_delay": 'With aggro order on, \n max delay in seconds between orders.',     
    "aggro_book_ratio": 'Example : 5,\n Ratio between bid/ask at 0.1% spread. Aggro orders will be allowed if bid vs ask ratio is > X.',     
    "aggro_forced_if_no_fill_in": "Will force an aggro order if you didn't get filled in X seconds",  
    "maker_only": "The order will be maker, unless it's an aggro order",
    "hedge_mode": "0: one-way mode, 1: hedge-mode Buy side, 2: hedge-mode Sell side",
    },
    settingsFields: {
      'trade':[
        "max_order_size",
        "trigger_price",
        "stop_price",
        "exit_price",
        "price_limit",
        "break_time_in",
        "break_time_out",
        "depth_min",
        "depth_max", 
        "cancel_price_gap",
        "price_limit_is_last_ex_price",
        "rdm_qty_range", 
        "aggro_order_on",
        "aggro_depth",
        "aggro_order_delay",
        "aggro_book_ratio",
        "aggro_forced_if_no_fill_in",
        "fill_delay",
        "algo_type",
        "maker_only", 
        "hedge_mode"
      ],
      'algo': [
        "max_order_size",
        "trigger_price",
        "trigger_instrument",
        "price_limit",
        "price_limit_is_last_ex_price", 
        "fill_delay",
        "depth_min",
        "depth_max", 
        "cancel_price_gap",
        "rdm_qty_range", 
        "aggro_order_on",
        "aggro_depth",
        "aggro_order_delay",
        "aggro_book_ratio",
        "aggro_forced_if_no_fill_in",
        "algo_type",
        "maker_only", 
        "hedge_mode"
      ]
    },

    stopSettingList: [
      "max_order_size",
      "depth_min",
      "depth_max", 
      "cancel_price_gap",
      "rdm_qty_range", 
      "aggro_order_on",
      "aggro_depth",
      "aggro_order_delay",
      "aggro_book_ratio",
      "aggro_forced_if_no_fill_in",
      "fill_delay",
      "maker_only", 
    ],

    settingsDetails: {
      "trade": {
        "targets": "Example: BTCUSDT:10000 \n ETHUSDT:-1000",
        "max_order_size": 'Order size will be capped at this value sometimes it can round slightly over if close to min_nominal',                      
        "trigger_price": 'Example: \n  >24000 <19000 \n >23000/>24000/>25000 \n default < if not specified', 
        "trigger_instrument": 'If trigger_price is specified \n it will use the first instrument in target as default \n else you can use this instead', 
        "stop_price": 'closed if price < or > stop_price (depend on long/short) (can be added/changed later)', 
        "exit_price": 'closed if price < or > exit_price (depend on long/short) (can be added/changed later)', 
        "price_limit": 'Example: 24000 \n 22000/23000/24000 \n will never trade > or < to price_limit \n (do not specify < or >)', 
        "break_time_in": 'Example: 10 \n 10/20/30/40 \n if we spend X minutes over trigger_price', 
        "break_time_out": 'Example : 5 \n if X % under trigger_price will reset break_time_in', 
        "stop_max_order_size": 'Order size of your stops/exits',      
        "depth_min": 'Example: 0.001 \n how deep we post our order in the book (in %)',     
        "depth_max": 'Example: 0.002 \n random between depth_min/depth_max (must be >= depth_min)',     
        "price_limit_is_last_ex_price": 'Example : 0 or 1 \n our last exPrice become our price_limit \n',    
        "cancel_price_gap": 'Example: 0.0001 \n do not touch',   
        "rdm_qty_range": 'If max_order_size is 1000 and rdm_qty_range is 20 we will post an order size between 800 and 1000 ',     
        "aggro_order_on": 'Example : 0 or 1 \n will allow to be taker',     
        "aggro_depth": 'How deep we will try to get filled with aggro in %',     
        "aggro_order_delay": 'In seconds \n Max delay between aggro orders',     
        "aggro_book_ratio": 'Example : 5\n Ratio between bid/ask at 0.1% spread if bid vs ask ratio is > X  \n allow aggro order ',     
        "aggro_forced_if_no_fill_in": 'Will force an aggro order if you didnt get filled in X seconds',     
        "fill_delay": 'Will wait X seconds to send another order when filled',     
        "algo_type": 'Leave blank or algo_nom \n WARNING: algo_nom target amount is in coin size \n Example: BTCUSDT:1 => you will have 1 BTC',
        "maker_only": "The order will be maker, unless it's an aggro order",
        "hedge_mode": "0: one-way mode, 1: hedge-mode Buy side, 2: hedge-mode Sell side",
      },
      "algo": {
        "targets": "Example: BTCUSDT:10000 \n ETHUSDT:-1000",
        "max_order_size": 'Order size will be capped at this value sometimes it can round slightly over if close to min_nominal',                      
        "trigger_price": 'Example: \n  >24000 <19000 \n >23000/>24000/>25000 \n default < if not specified', 
        "trigger_instrument": 'If trigger_price is specified \n it will use the first instrument in target as default \n else you can use this instead', 
        "stop_price": 'closed if price < or > stop_price (depend on long/short) (can be added/changed later)', 
        "exit_price": 'closed if price < or > exit_price (depend on long/short) (can be added/changed later)', 
        "price_limit": 'Example: 24000 \n 22000/23000/24000 \n will never trade > or < to price_limit \n (do not specify < or >)', 
        "break_time_in": 'Example: 10 \n 10/20/30/40 \n if we spend X minutes over trigger_price', 
        "break_time_out": 'Example : 5 \n if X % under trigger_price will reset break_time_in', 
        "stop_max_order_size": 'Order size of your stops/exits',      
        "depth_min": 'Example: 0.001 \n how deep we post our order in the book (in %)',     
        "depth_max": 'Example: 0.002 \n random between depth_min/depth_max (must be >= depth_min)',     
        "price_limit_is_last_ex_price": 'Example : 0 or 1 \n our last exPrice become our price_limit \n',    
        "cancel_price_gap": 'Example: 0.0001 \n do not touch',   
        "rdm_qty_range": 'If max_order_size is 1000 and rdm_qty_range is 20 we will post an order size between 800 and 1000 ',     
        "aggro_order_on": 'Example : 0 or 1 \n will allow to be taker',     
        "aggro_depth": 'How deep we will try to get filled with aggro in %',     
        "aggro_order_delay": 'In seconds \n Max delay between aggro orders',     
        "aggro_book_ratio": 'Example : 5\n Ratio between bid/ask at 0.1% spread if bid vs ask ratio is > X  \n allow aggro order ',     
        "aggro_forced_if_no_fill_in": 'Will force an aggro order if you didnt get filled in X seconds',     
        "fill_delay": 'Will wait X seconds to send another order when filled',     
        "algo_type": 'Leave blank or algo_nom \n WARNING: algo_nom target amount is in coin size \n Example: BTCUSDT:1 => you will have 1 BTC',
        "maker_only": "The order will be maker, unless it's an aggro order",
        "hedge_mode": "0: one-way mode, 1: hedge-mode Buy side, 2: hedge-mode Sell side",
      }
 
    },
    emptyFields: false, 

    setEmptyFieldsOn: () => {
      set({emptyFields: true})
    },
    setEmptyFieldsOff: () => {
      set({emptyFields: false})
    },
    clearSelectedSetting: () => {
      console.log("CLEAR")
      set({ selectedSetting: {} });
    },
    
    fetchSettings: async() => {
      console.log('FETCHING SETTINGS')
      const token = Cookies.get('token')
      const res = await axios({
      headers: { Authorization: token},
      method: "GET",
      url : '/api/fetch_settings',
      token : token,      
      timeout : 10000
    })
    set(produce(state => {state.settings =  res.data}))
    
    },
    reloadSettings: async(settings_data) => {
      get().fetchSettings()
    },
    selectSetting: (setting_name) => {   
      console.log('SELECT')   
      set({selectedSetting: get().settings[setting_name]})
    },
    setDefaultSelected: () => {
      set({selectedSetting: get().settings["default"]})
    },
 
    
}))


export default useSettingsStore;